import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import MainContent from "./sections/MainContent";
import ColetaEUsoDeDados from "./sections/ColetaEUsoDeDados";
import UserRightsAndObligations from "./sections/UserRightsAndObligations";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <MainContent />
      <ColetaEUsoDeDados />
      <UserRightsAndObligations />
      <Footer />
    </div>;
}